import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import classes from './Modal.module.css'

const Modal = ({ children, onClose, invoiceNumber }) => {
    const componentRef = useRef()
    const modalRef = useRef()

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Invoice ${invoiceNumber}`,
    })

    const handleOverlayClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose()
        }
    }

    return (
        <div className={classes.overlay} onClick={handleOverlayClick}>
            <div className={classes.modal} ref={modalRef}>
                <button className={classes.closeBtn} onClick={onClose}>
                    ×
                </button>

                <div className={classes.body}>
                    {/* Content to print */}
                    <div ref={componentRef} className={classes.printArea}>
                        {children}
                    </div>

                    <div className={classes.actions}>
                        <button onClick={handlePrint} className={classes.printBtn}>
                            Print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal
